import React from "react";
import BForm from "../../components/forms/BForm";

export default function OffertsForm({
  onSubmit,
  btnText,
  preloadedData,
  success,
  responseErrors,
}) {
  const fields = [
    {
      fieldName: "title",
      placeholder: "Titel",
      validation: {
        required: true,
      },
    },
    {
      fieldName: "message",
      placeholder: "Nachricht",
      validation: {
        required: true,
      },
      type: "textarea",
      cols: 40,
      rows: 10,
    },
    {
      fieldName: "image",
      placeholder: "Bild",
      validation: {
        required: true,
      },
      type: "file",
    },
    {
      fieldName: "propertyType",
      placeholder: "Immobilienstyp",
      validation: {
        required: true,
      },
      type: "select",
      options: [
        { label: "Haus", value: 0 },
        { label: "Wohnung", value: 1 },
        { label: "Paket", value: 2 },
      ],
    },
    {
      fieldName: "url",
      placeholder: "Link",
      validation: {
        required: true,
      },
    },
    {
      fieldName: "zipCode",
      placeholder: "Postleitzahlen durch Kommas trennen",
      validation: {
        required: true,
        pattern: {
          value: /[0-9]{4}$/,
          message: "This isn't valid zip code!",
        },
      },
    },
  ];

  return (
    <BForm
      preloadedData={preloadedData}
      btnText={btnText}
      submit={onSubmit}
      fields={fields}
      success={success}
      responseErrors={responseErrors}
    />
  );
}
